<template>
  <el-dialog custom-class="add-invoice-apply" title="新增发票申请" width="500px" :close-on-click-modal="false" :visible.sync="visible">
    <el-form ref="form" label-width="100px" size="small" :model="form" :rules="rules">
      <el-form-item label="发票类型" prop="invoiceImgs">
        <el-select placeholder="请选择发票类型" v-model="form.invoiceType">
          <el-option v-for="(item, index) in invoiceTypes" :key="index" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开票类目" prop="invoiceClass">
        <el-select placeholder="请选择开票类目" v-model="form.invoiceClass" v-el-select-loadmore="handleLoadMore">
          <el-option v-for="(item, index) in invoiceClassList" :key="index" :label="item.invoiceClassName" :value="item.invoiceClassId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开票金额" prop="invoiceAmount">
        <el-input-number placeholder="请输入开票金额" v-model="form.invoiceAmount" :min="0" controls-position="right"></el-input-number>
      </el-form-item>
      <el-form-item label="留言" prop="applyRemark">
        <el-input placeholder="请填写留言，最多不超过100字" maxlength="100" type="textarea" v-model="form.applyRemark"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="invoice-footer">
      <el-button size="small" @click="handleCancel">取消</el-button>
      <el-button size="small" type="primary" @click="handleConfirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { invoiceTypes } from '@/utils/enum';

export default {
  name: 'addInvoceApply',
  props: {
    invoiceClassList: Array,
  },
  data() {
    return {
      invoiceTypes,
      visible: false,
      form: {
        invoiceType: 1,
        invoiceClass: '',
        invoiceAmount: 0,
        applyRemark: '',
      },
      rules: {
        invoiceType: [{ required: true, message: '请选择发票类型', trigger: 'change' }],
        invoiceClass: [{ required: true, message: '请选择开票类目', trigger: 'change' }],
        invoiceAmount: [{ type: 'number', required: true, message: '请输入开票金额', trigger: 'blur' }],
      },
    };
  },
  methods: {
    show() {
      this.visible = true;
    },
    close() {
      this.$refs.form.resetFields();
      this.visible = false;
    },
    handleLoadMore() {
      this.$emit('loadMore');
    },
    handleCancel() {
      this.close();
    },
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('confirm', this.form);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.add-invoice-apply {
  /deep/ .el-input-number--small {
    width: 100%;
  }
  /deep/ .el-input-number .el-input__inner {
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/invoice/components/addInvoiceApply.vue